/*
 * Auth Thresholds
 */
export const AUTH_RETURN_URL_COOKIE_EXPIRATION = 1800000;
export const AUTH_TOKEN_REFRESH_INTERVAL = 2700000; 
export const AUTH_TOKEN_EXPIRATION_THRESHOLD = 300000;
export const AUTH_TOKEN_EXPIRATION_CHECK_THRESHOLD = 1500000;
export const AUTH_REFRESH_TOKEN_EXPIRATION_THRESHOLD = 300000;